import type { ChangeEvent, FocusEvent } from "react";
import { Input, Button } from "@porchpass/ui";
import { EyeOpenIcon, EyeClosedIcon } from "src/assets/icons";
import { Link } from "react-router-dom";

interface EmailFormProps {
  emailValue: string;
  passwordValue: string;
  showEmailError: boolean;
  showPasswordError: boolean;
  showPassword: boolean;
  onEmailChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onEmailFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onEmailBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onPasswordChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onPasswordFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onPasswordBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onToggleShowPassword: () => void;
  onSubmit: () => void;
  loading: boolean;
}

export const EmailForm: React.FC<EmailFormProps> = ({
  emailValue,
  passwordValue,
  showEmailError,
  showPasswordError,
  showPassword,
  onEmailChange,
  onEmailFocus,
  onEmailBlur,
  onPasswordChange,
  onPasswordFocus,
  onPasswordBlur,
  onToggleShowPassword,
  onSubmit,
  loading,
}) => (
  <form
    className="w-[410px]"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <div className="relative mb-5 w-full">
      <Input
        value={emailValue}
        placeholder="Email"
        error={showEmailError}
        helperText={showEmailError ? "Email is invalid" : undefined}
        onChange={onEmailChange}
        onFocus={onEmailFocus}
        onBlur={onEmailBlur}
        size="m"
        type="email"
        data-testid="email-login-input"
      />
    </div>
    <div className="relative mb-5 w-full">
      <Input
        value={passwordValue}
        placeholder="Password"
        error={showPasswordError}
        helperText={showPasswordError ? "Password cannot be empty" : undefined}
        onChange={onPasswordChange}
        onFocus={onPasswordFocus}
        onBlur={onPasswordBlur}
        type={showPassword ? "text" : "password"}
        size="m"
        data-testid="password-login-input"
        rightSlot={
          <div className="flex gap-3 items-center">
            <Link
              to="/login/forgot-password"
              className="whitespace-nowrap transition-colors text-3xs hover:text-blue-600"
            >
              Forgot password
            </Link>
            <Button
              type="button"
              variant="ghost"
              size="icon-sm"
              onClick={onToggleShowPassword}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </Button>
          </div>
        }
      />
    </div>
    <Button
      variant="primary"
      size="m"
      type="submit"
      loading={loading}
      disabled={showEmailError || showPasswordError}
      className="w-full"
    >
      Sign In
    </Button>
  </form>
);
